import {
  CardapioEstabelecimentoDTO,
  CardapioCategoriaDTO,
  CardapioFreteDTO,
} from '../../models/cardapio-digital/cardapio-digital.model';

/**
 * Dados mock para desenvolvimento/teste do cardapio digital.
 * Usado apenas quando o backend nao esta disponivel (ambiente de desenvolvimento).
 */

export const MOCK_ESTABELECIMENTO: CardapioEstabelecimentoDTO = {
  empresaId: 0,
  nome: 'Restaurante Demo',
  slug: 'restaurante-demo',
  telefoneWhatsapp: '595981123456',
  endereco: 'Av. Principal 1234, Asuncion',
  horarioFuncionamento: 'Seg-Sex: 11h-23h | Sab-Dom: 11h-00h',
  aberto: true,
  logo: null,
  banner: null,
  corDeFundo: '#FFFFFF',
  corDaFonte: '#333333',
  botoesCorDeFundo: '#007BFF',
  botoesCorDaFonte: '#FFFFFF',
  perfilInstagram: 'restaurante_demo',
};

export const MOCK_CATEGORIAS: CardapioCategoriaDTO[] = [
  {
    id: 1, nome: 'Platos Principales', ordem: 1,
    produtos: [
      { id: 1, nome: 'Hamburguesa Clasica', descricao: 'Una deliciosa hamburguesa con todos los ingredientes frescos.', preco: 30000, foto: null, modificadores: [
        { id: 1, nome: 'Tamano', obrigatorio: true, minimoSelecoes: 1, maximoSelecoes: 1, opcoes: [
          { id: 1, nome: 'Pequeno', precoAdicional: 0 }, { id: 2, nome: 'Mediano', precoAdicional: 5000 }, { id: 3, nome: 'Grande', precoAdicional: 10000 },
        ]},
        { id: 2, nome: 'Extras', obrigatorio: false, minimoSelecoes: 0, maximoSelecoes: 3, opcoes: [
          { id: 4, nome: 'Queso extra', precoAdicional: 3000 }, { id: 5, nome: 'Bacon', precoAdicional: 5000 }, { id: 6, nome: 'Huevo frito', precoAdicional: 3500 },
        ]},
      ]},
      { id: 2, nome: 'Pizza Margherita', descricao: 'Pizza clasica con salsa de tomate, mozzarella y albahaca.', preco: 45000, precoPromocional: 38000, percentualDesconto: 16, foto: null, modificadores: [
        { id: 3, nome: 'Tamano', obrigatorio: true, minimoSelecoes: 1, maximoSelecoes: 1, opcoes: [
          { id: 7, nome: 'Individual', precoAdicional: 0 }, { id: 8, nome: 'Familiar', precoAdicional: 20000 },
        ]},
      ]},
      { id: 3, nome: 'Ensalada Cesar', descricao: 'Fresca ensalada con pollo a la parrilla y aderezo especial.', preco: 25000, foto: null, modificadores: [] },
      { id: 4, nome: 'Tacos al Pastor', descricao: 'Dos tacos de carne de cerdo marinada con pina y cilantro.', preco: 22000, foto: null, modificadores: [] },
    ],
  },
  {
    id: 2, nome: 'Postres', ordem: 2,
    produtos: [
      { id: 5, nome: 'Bolo de Chocolate', descricao: 'Delicioso pastel de chocolate con cobertura cremosa.', preco: 22000, foto: null, modificadores: [] },
      { id: 6, nome: 'Helado Artesanal', descricao: 'Helado cremoso hecho en casa con ingredientes naturales.', preco: 18000, foto: null, modificadores: [] },
    ],
  },
  {
    id: 3, nome: 'Bebidas', ordem: 3,
    produtos: [
      { id: 7, nome: 'Agua Mineral', descricao: 'Agua mineral natural 500ml.', preco: 6000, foto: null, modificadores: [] },
      { id: 8, nome: 'Coca-Cola', descricao: 'Coca-Cola clasica 350ml.', preco: 8000, foto: null, modificadores: [] },
      { id: 9, nome: 'Jugo Natural', descricao: 'Jugo de frutas frescas, recien exprimido.', preco: 12000, foto: null, modificadores: [] },
    ],
  },
];

export const MOCK_FRETE: CardapioFreteDTO = {
  valorFixo: 8000,
  valorMinimoFreteGratis: 80000,
  ativo: true,
};
